export default __webpack_public_path__ + "static/media/B02.0fcc98fa.png";